import React from 'react';
import '../styles/Navigation.css';

export default function Navigation({ currentPage }) {
  return (
    <nav className="tool-nav">
      <ul className="nav-menu">
        <li>
          <a 
            href="/" 
            className={`nav-item ${currentPage === 'analysis' ? 'active' : ''}`}
          >
            📊 Advanced Analysis
          </a>
        </li>
        <li>
          <a 
            href="/pages/competitor" 
            className={`nav-item ${currentPage === 'competitor' ? 'active' : ''}`}
          >
            🏆 Competitor Analysis
          </a>
        </li>
        <li>
          <a 
            href="/pages/trending" 
            className={`nav-item ${currentPage === 'trending' ? 'active' : ''}`}
          >
            🔥 Trending Keywords
          </a>
        </li>
      </ul>
    </nav>
  );
}
